import { render } from 'react-dom'
import React from 'react'
import './styles.css'
import { App } from './app'

render(<App />, document.querySelector('#root'))
